import React from 'react';

import {TopHolder} from "libs/api/invest/generated/schema";

import ColorBox from './ColorBox';
import './styles.scss';

const DashboardHoldersGrid = (props: {
  holders: TopHolder[]
  holderName?: string
  currencySign: string
}) => {
  return (
    <table className="w-100">
      <thead>
        <tr style={{borderTop: '1px solid #e9ecef'}}>
          <th>Investor</th>
          <th>Investment Amount</th>
          <th>Holdings</th>
        </tr>
      </thead>
      <tbody>
        {props.holders.length > 0 &&
          props.holders.map(holder => (
            <tr
              key={holder.name}
              className={props.holderName && props.holderName === holder.name ? 'table-active odd' : ''}
              style={{borderTop: '1px solid #e9ecef'}}
            >
              <td>
                <ColorBox className="mx-2" color={holder.color} />
                {holder.name}
              </td>
              <td>
                {props.currencySign}{holder.holdingsAmount.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
              </td>
              <td>{Math.round(holder.holdingsPercent)}%</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default DashboardHoldersGrid;
